/**
 * Do not edit directly
 * Generated on Thu, 19 Aug 2021 21:48:11 GMT
 */
export const FontNormal = "noto-sans, noto-sans-cjk-jp, noto-sans-cjk-kr, \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
export const FontTitle = "poppins, noto-sans, noto-sans-cjk-jp, noto-sans-cjk-kr, \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
export const FontWeightLight = 300;
export const FontWeightDefault = 400;
export const FontWeightSemibold = 600;
export const FontWeightBold = 700;
export const FontMicroSize = "8px";
export const FontMicroLineHeight = "12px";
export const FontLeftRailSize = "10px";
export const FontLeftRailLineHeight = "10px";
export const FontXsSize = "10px";
export const FontXsLineHeight = "16px";
export const FontSSize = "12px";
export const FontSLineHeight = "16px";
export const FontMSize = "14px";
export const FontMLineHeight = "20px";
export const FontLinkSize = "14px";
export const FontLinkLineHeight = "20px";
export const FontLSize = "16px";
export const FontLLineHeight = "24px";
export const FontHeader4Size = "18px";
export const FontHeader4LineHeight = "24px";
export const FontHeader3Size = "24px";
export const FontHeader3LineHeight = "32px";
export const FontHeader2Size = "32px";
export const FontHeader2LineHeight = "40px";
export const FontHeader1Size = "36px";
export const FontHeader1LineHeight = "44px";
export const FontHeroSize = "64px";
export const FontHeroLineHeight = "72px";
